import { Component, ViewContainerRef } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { RightPanelComponent } from "../../../../right-panel/right-panel.component";
import { ModalComponent } from "../../../../modal/modal.component";
import { AdvancedFilterComponent } from "../../../../advanced-filter/advanced-filter.component";
import { TableListRequest } from "../../../../../models/table-list-request.interface";
import { FileUploadComponent } from "../../../../file-upload/file-upload.component";
import { FileUploadDialogComponent } from "../../file-upload-dialog/file-upload-dialog.component";
import { EditableTableComponent } from "../../../../editable-table/editable-table.component";
import { DatePipe, NgClass, NgForOf, NgIf } from "@angular/common";
import { HighlightPipe } from "../../../../../pipes/highlight.pipe";
import { NoDataComponent } from "../../../../no-data/no-data.component";
import { NoDataFoundComponent } from "../../../../no-data-found/no-data-found.component";
import { ResizableModule, ResizeEvent } from "angular-resizable-element";
import { SvgIconComponent } from "../../../../svg-icon/svg-icon.component";
import { TableMenuComponent } from "../../../../table-menu/table-menu.component";
import { PaginatedListDataResponse } from "../../../../../models/paginated-list-data-response";
import { LoadingService } from "../../../../../services/loading.service";
import { OperationService } from "../../../../../services/operations.service";
import { User } from "../../../../../models/user.interface";
import { Where } from "../../../../../models/user-list-request.interface";
import { AdvancedFilterComponentV2 } from "../../../../advanced-filter/advanced-filter-v2.component";
import igmVesselConfig from "../../config/igm-vessel-config.json";
import { AdvancedFilterFieldInfo } from "../../../../../models/advanced-filter-config.interface";
import { TableMeta } from "../../../../../models/table-meta.interface";
import { TosTableComponent } from "../../../../tos-table/tos-table.component";
import { StaticTableComponent } from "../../../../static-table/static-table.component";
import { filter } from "rxjs/operators";
import { ActivatedRoute, Router } from "@angular/router";
import { InventoryService } from "../../../../../services/inventory-service";
import { ApiService } from "../../../../../services/api.service";

@Component({
  selector: "app-igm-vessel",
  standalone: true,
  imports: [
    FormsModule,
    EditableTableComponent,
    DatePipe,
    HighlightPipe,
    NgForOf,
    NgIf,
    NoDataComponent,
    NoDataFoundComponent,
    ResizableModule,
    SvgIconComponent,
    TableMenuComponent,
    TosTableComponent,
    NgClass
  ],
  templateUrl: "./igm-vessel.component.html",
  styleUrl: "./igm-vessel.component.scss"
})
export class ManageIGMVesselComponent {
  protected readonly igmVesselConfig = igmVesselConfig;
  filterFields = [
    {
      displayName: 'Container Number',
      key: 'containerNo',
    },
    {
      displayName: 'Vessel Id',
      key: 'vesselId',
    },
  ];
  isFilterApplied: boolean = false;
  searchTerm: any;
  focusSearch!: boolean;
  tableLoaded: boolean = false;
  tableMeta!: TableMeta;
  tableListData: PaginatedListDataResponse = {
    totalCount: 0,
    page: 0,
    limit: 0,
    records: []
  };
  sortColumn: string = "modifiedDate";
  openMenuIndex: number | null = null;
  menuOptions = [
    { label: 'View Items', value: 'viewItems' }
  ];
  totalTablePages: number = 0;
  currentTablePage: number = 1;
  sortDirection: "asc" | "desc" = "desc";
  rowsPerPage: number = 25;
  currentPage: number = 0;
  filterData: Where | null = null;
  rawFilterData: Where | null = null;
  searchFilterData!: Where | null;
  tableListRequest: TableListRequest = {
    orderBy: {
      [this.sortColumn]: this.sortDirection
    },
    limit: this.rowsPerPage,
    includeTotal: true,
    page: this.currentPage
  };
  allTableRecordsSelected: boolean = false;
  selectedItems: any[] = [];
  previousTerm: string = "";

  defaultFilters: Where = {
      filterConditions: [
      {
        name: "IS_ACTIVE",
        alias: "active",
        value: ["true"]
      }
    ],
    expression: "active"
  }

  constructor(private viewContainerRef: ViewContainerRef,
              private loadingService: LoadingService,
              private operationService: OperationService,
              private api: ApiService,
              private router: Router,
              private route: ActivatedRoute) {
  }

  ngOnInit(){
    this.tableMeta = igmVesselConfig.vesselTableConfig;
    this.fetchAllRecords()
  }

  fetchAllRecords() {
    this.loadingService.show('inline');
    this.api.getVesselMasterList(this.tableListRequest).subscribe({
      next: (res: any) => {
        this.tableListData = res.data;
        this.calculateTotalPages();
        this.tableLoaded = true;
        this.loadingService.hide()

      },
      error: (error: Error) => {
        console.error("Error occurred:", error);
        this.tableLoaded = false;
        this.loadingService.hide()
      }
    });
  }


  uploadFile() {
    const rightPanelRef = this.viewContainerRef.createComponent(RightPanelComponent);
    rightPanelRef.instance.title = "Upload File";
    rightPanelRef.instance.showActionBtns = true;
    rightPanelRef.instance.primaryActionBtnText = "Upload";

    const fileUploadDialogRef = rightPanelRef.instance.loadComponent(
      FileUploadDialogComponent
    );

    rightPanelRef.instance.primaryActionBtnEmitter.subscribe(() => {
      fileUploadDialogRef.instance.onSubmit()
    })

    fileUploadDialogRef.instance.refreshTableData.subscribe(() => {
      this.fetchAllRecords();
    });

    rightPanelRef.instance.close.subscribe((res: any) => {
      if (res && res.refresh) {
        this.refreshTableList();
      }
      rightPanelRef.destroy();
    });
  }

  // private viewContainerItems(container: any) {
  //   this.fetchContainerItems(container.id, (items) => {
  //     const rightPanelRef = this.viewContainerRef.createComponent(RightPanelComponent);
  //     rightPanelRef.instance.title = "Associated items for " + container.containerNo;

  //     const loginHistoryRef = rightPanelRef.instance.loadComponent(StaticTableComponent, { data: items, tableMeta: igmDeskConfig.itemTableConfig, readOnlyMode: true });

  //     rightPanelRef.instance.close.subscribe((res: any) => {
  //       if (res && res.refresh) {
  //         this.refreshTableList();
  //       }
  //       rightPanelRef.destroy();
  //     });
  //   });

  // }



  private clearSelection() {
    this.selectedItems = [];
  }

  private refreshTableList() {
    this.fetchAllRecords()
  }



  isAllRecordsOfCurrentPageSelected() {
    return (
      this.allTableRecordsSelected ||
      (this.tableListData.records?.length > 0 &&
        this.tableListData.records?.every((item: User) =>
          this.isSelected(item)
        ))
    );

  }

  toggleAllRecordsOfCurrentPageSelections(checked: any) {
    if (checked) {
      this.tableListData.records?.forEach((item) => {
        if (!this.isSelected(item)) {
          this.selectedItems.push(item);
        }
      });
    } else {
      this.tableListData.records?.forEach((item) => {
        this.selectedItems = this.selectedItems.filter((i) => i.id !== item.id);
      });
    }
  }

  onResizeEnd(event: ResizeEvent, column: string) {
    if (event.edges.right) {
      const columnHeader = document.querySelector(`th.${column}_th`) as HTMLElement;
      const columnCells = document.querySelectorAll(`td.${column}_td`);
      const newWidth = `${event.rectangle.width}px`;

      if (columnHeader) {
        columnHeader.style.width = newWidth;
      }

      columnCells.forEach(cell => {
        const cellHtml = cell as HTMLElement;
        cellHtml.style.width = newWidth;
      });
    }
  }



  isSelected(item: any) {
    if (this.allTableRecordsSelected) {
      return true;
    } else {
      const recordIdx = this.selectedItems.findIndex((x) => x.id === item.id);
      if (recordIdx !== -1) {
        return true;
      } else {
        return false;
      }
    }
  }

  toggleSelection(item: any) {
    if (!this.isSelected(item)) {
      this.selectedItems.push(item);
    } else {
      this.selectedItems = this.selectedItems.filter((i) => i.id !== item.id);
    }
  }

  handleMenuToggle(i: number) {
    this.openMenuIndex = this.openMenuIndex === i ? null : i;
  }

  handleOptionSelected(record: any, actionName: any) {
    console.log(record);
    const recordId = record.id;
  }

  handleMenuOptionSelection(event: any) {
      const { record, actionName } = event;
      const recordId = record.id;
      if (actionName === 'view') {
        this.router.navigate([`view/${recordId}`], { relativeTo: this.route });
      } else if (actionName === 'viewItems') {
        //this.viewVesselItems(record);
      }
  }

  previousPage() {
    if (this.currentTablePage > 1) {
      this.currentTablePage--;
      this.tableListRequest.page = this.currentTablePage - 1;
      this.fetchAllRecords();
    }
  }



  calculateTotalPages() {
      this.totalTablePages = Math.ceil(
        (this.tableListData?.totalCount || 50) / this.rowsPerPage
      );
  }





  fetchContainerItems(containerId: any, callback: (items: any[] | null) => void): void {
    this.operationService.getImportCargoByContainerId(containerId).subscribe({
      next: (res: any) => {
        callback(res.data);
      },
      error: (err) => {
        console.log(err);
        callback(null);
      },
    });
  }

  private viewVesselItems(container: any) {
    this.fetchContainerItems(container.id, (items) => {
      const rightPanelRef = this.viewContainerRef.createComponent(RightPanelComponent);
      rightPanelRef.instance.title = "Associated items for " + container.containerNo;

      const loginHistoryRef = rightPanelRef.instance.loadComponent(StaticTableComponent, { data: items, tableMeta: igmVesselConfig.itemTableConfig, readOnlyMode: true });

      rightPanelRef.instance.close.subscribe((res: any) => {
        if (res && res.refresh) {
          this.refreshTableList();
        }
        rightPanelRef.destroy();
      });
    });

  }
}
